import { getApiConfig } from "../../../settings/api";
import { AxiosResponse } from "axios";
import { Action } from "redux-saga";
import {
  call,
  CallEffect,
  delay,
  PutEffect,
  SelectEffect,
  select,
} from "redux-saga/effects";
import { ReducersTypes } from "@/redux/reducers/Models";
import { Debts } from "@/utils/transform";

export const INITIAL_DEBTS_POLL_INTERVAL_MS = 2000;
export const MAX_DEBTS_POLL_INTERVAL_MS = 10000;

export type DebtsPullingCallback = (
  success: boolean,
  code?: string | Debts[],
  partialPassages?: Debts[],
) => void;

export interface Fetch {
  requestId: string;
  callback: DebtsPullingCallback;
  pollIntervalMs?: number;
}

export interface DebtsPullingAction {
  type: string;
  payload: Fetch;
}

export default function* debtsPulling({
  payload,
}: DebtsPullingAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  let interval =
    payload.pollIntervalMs ?? INITIAL_DEBTS_POLL_INTERVAL_MS;

  const getCustomer = (state: ReducersTypes) => state.customerReducer;

  while (true) {
    try {
      // @ts-expect-error
      const customer: ReducersTypes["customerReducer"] =
        yield select(getCustomer);
      const isLogged = Boolean(customer?.accessToken);

      const { apiInstance, prefixUri } = getApiConfig(isLogged);
      const response = yield call(
        apiInstance.get,
        `${prefixUri}/v1/vehicle-debts/status/${payload.requestId}`,
      );

      const statusData = response?.data?.data;
      const flSituacao = statusData?.flSituacao;
      const passagens = statusData?.passagens as Debts[] | undefined;

      if (flSituacao === 2) {
        yield call(payload.callback, true, passagens);
        return;
      }

      if (flSituacao === 3) {
        yield call(payload.callback, false, "timeout");
        return;
      }

      yield call(payload.callback, false, "again", passagens);
    } catch (error) {
      yield call(payload.callback, false, "timeout");
      return;
    }

    yield delay(interval);
    interval = Math.min(interval * 2, MAX_DEBTS_POLL_INTERVAL_MS);
  }
}
